export enum NodeName {
  Doc = 'doc',
  Paragraph = 'paragraph',
  Text = 'text',
  Heading = 'heading',
  Blockquote = 'blockquote',
  HardBreak = 'hard_break',
  OrderedList = 'ordered_list',
  BulletList = 'bullet_list',
  Checklist = 'checklist',
  ListItem = 'list_item',
  ChecklistItem = 'checklist_item',
  Mention = 'mention',
  LegacyMention = 'legacy_mention',
  Placeholder = 'placeholder',
  Link = 'scheduler_link',
  Image = 'image',
  Video = 'video',
  Column = 'column',
  Columns = 'columns',
}
